export enum ALERT_SOURCE {
    DAILY_WARNING = 'DAILY_WARNING', // ข่าวเตือนภัยรายวัน
    SYSTEM_GENERATED = 'SYSTEM_GENERATED', // สร้างจากระบบ
}

export const ALERT_SOURCE_DATA: { label: string, value: string }[] = [
    {
        label: "ข่าวเตือนภัยรายวัน", // i18n-ignore: translated at render site
        value: ALERT_SOURCE.DAILY_WARNING
    },
    {
        label: "สร้างจากระบบ", // i18n-ignore: translated at render site
        value: ALERT_SOURCE.SYSTEM_GENERATED
    },
]

export enum BANNER_GROUP {
    HOME = 'หน้าหลัก', // i18n-ignore
    ADMISSION = 'Admission', // Admission
    NEWS = 'ข่าวประชาสัมพันธ์', // i18n-ignore
    ACTIVITY = 'ปฏิทินกิจกรรม', // i18n-ignore
}

export const banner_group_data: { label: string, value: string }[] = Object.entries(BANNER_GROUP).map(([key, value]) => {
    return {
        label: value,
        value: key
    }
})